import React from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "@hooks";

type ProtectedPageProps = {
  redirect?: string;
};

/**
 * A wrapper for a page that is intended to be accessible via authenticated
 * users only. To use this, keep the ProtectedPage element as the top level
 * element of the page, and pass everything else to the ProtectedPage as
 * children.
 * @param { JSX.Element } children Protected Page Contexts.
 * @param { string|undefined } redirect route to redirect to (default "/login")
 * @returns { JSX.Element } Redirect to login if user is not logged in.
 */
export function ProtectedPage({
  children,
  redirect = "/login",
}: React.PropsWithChildren<ProtectedPageProps>): JSX.Element {
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();

  React.useEffect(() => {
    if (!isLoggedIn) return navigate(redirect);
  }, [isLoggedIn, navigate, redirect]);

  if (!isLoggedIn) return <></>;
  return <>{children}</>;
}
